import { Job as JobProto, State } from "protos/rtc/jobs";

// helper functions to indicate whether certain state transitions are allowed
// for a given autotractor job.  the validity of these transitions is enforced
// by the jobs API server, but local helpers are useful for visual cues to the
// user.
export function jobIsStartable(job: JobProto): boolean {
  return job.state === State.PENDING || job.state === State.PAUSED;
}

export function jobIsPauseable(job: JobProto): boolean {
  return job.state === State.IN_PROGRESS;
}

export function jobIsCancellable(job: JobProto): boolean {
  return (
    job.state === State.PENDING ||
    job.state === State.READY ||
    job.state === State.IN_PROGRESS ||
    job.state === State.PAUSED
  );
}
